// API Configuration
// REACT_APP_API_URL wins when set. Otherwise production builds default to the
// real API host — a bare `npm run build` must NEVER ship a bundle that calls
// localhost (it happened 2026-07-17: prod login broke until redeployed).
const API_BASE_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? 'https://api.theezdocs.com' : 'http://localhost:5000');

// API endpoints
export const API_ENDPOINTS = {
  // AWS Image Links
  AWS_IMAGE_LINKS_UPLOAD_IMAGES: `${API_BASE_URL}/api/AWSImageLinks/upload-images`,
  AWS_IMAGE_LINKS_PROCESS_EXCEL: `${API_BASE_URL}/api/AWSImageLinks/process-excel-images`,
  AWS_IMAGE_LINKS_UPLOAD_FILES: `${API_BASE_URL}/api/AWSImageLinks/upload-files`,
  AWS_IMAGE_LINKS_STATUS: (processId) => `${API_BASE_URL}/api/AWSImageLinks/status/${processId}`,
  AWS_IMAGE_LINKS_DOWNLOAD: (processId) => `${API_BASE_URL}/api/AWSImageLinks/download/${processId}`,
  AWS_IMAGE_LINKS_SAMPLE: `${API_BASE_URL}/api/AWSImageLinks/sample`,

  // CAD Invoices
  CAD_INVOICES_PROCESS: `${API_BASE_URL}/api/cadinvoices/process-invoices`,
  CAD_INVOICES_STATUS: (processId) => `${API_BASE_URL}/api/cadinvoices/status/${processId}`,
  CAD_INVOICES_DOWNLOAD: (processId) => `${API_BASE_URL}/api/cadinvoices/download/${processId}`,

  // Price Scraper V2 — QVC catalog (on-demand crawl)
  PRICE_SCRAPER_V2_RAYMOUR_CATALOG_START:  `${API_BASE_URL}/api/PriceScraper/v2/raymour-catalog/start`,
  PRICE_SCRAPER_V2_RAYMOUR_CATALOG_STATUS: `${API_BASE_URL}/api/PriceScraper/v2/raymour-catalog/status`,
  PRICE_SCRAPER_V2_RAYMOUR_CATALOG_CANCEL: `${API_BASE_URL}/api/PriceScraper/v2/raymour-catalog/cancel`,
  PRICE_SCRAPER_V2_OVERSTOCK_CATALOG_START:  `${API_BASE_URL}/api/PriceScraper/v2/overstock-catalog/start`,
  PRICE_SCRAPER_V2_OVERSTOCK_CATALOG_STATUS: `${API_BASE_URL}/api/PriceScraper/v2/overstock-catalog/status`,
  PRICE_SCRAPER_V2_OVERSTOCK_CATALOG_CANCEL: `${API_BASE_URL}/api/PriceScraper/v2/overstock-catalog/cancel`,
  PRICE_SCRAPER_V2_BEYOND_PARTNER_STATUS: `${API_BASE_URL}/api/PriceScraper/v2/beyond-partner/status`,
  PRICE_SCRAPER_V2_BEYOND_PARTNER_UPLOAD: `${API_BASE_URL}/api/PriceScraper/v2/beyond-partner/upload`,
  PRICE_SCRAPER_V2_BELK_CATALOG_START:  `${API_BASE_URL}/api/PriceScraper/v2/belk-catalog/start`,
  PRICE_SCRAPER_V2_BELK_CATALOG_STATUS: `${API_BASE_URL}/api/PriceScraper/v2/belk-catalog/status`,
  PRICE_SCRAPER_V2_BELK_CATALOG_CANCEL: `${API_BASE_URL}/api/PriceScraper/v2/belk-catalog/cancel`,
  PRICE_SCRAPER_V2_QVC_CATALOG_START:  `${API_BASE_URL}/api/PriceScraper/v2/qvc-catalog/start`,
  PRICE_SCRAPER_V2_QVC_CATALOG_STATUS: `${API_BASE_URL}/api/PriceScraper/v2/qvc-catalog/status`,
  PRICE_SCRAPER_V2_QVC_CATALOG_CANCEL: `${API_BASE_URL}/api/PriceScraper/v2/qvc-catalog/cancel`,

  // Pallet Optimizer
  PALLET_OPTIMIZER_OPTIMIZE: `${API_BASE_URL}/api/PalletOptimizer/optimize`,
  PALLET_OPTIMIZER_DIM_CAPACITY: `${API_BASE_URL}/api/PalletOptimizer/dim-capacity`,

  // PDF Processing
  PDF_PROCESS: `${API_BASE_URL}/api/pdf/process`,
  PDF_DOWNLOAD: (encodedUrl) => `${API_BASE_URL}/api/pdf/download/${encodedUrl}`,

  // Amazon Label Separator
  AMAZON_LABEL_SEPARATE: `${API_BASE_URL}/api/amazonlabelseparator/separate-labels`,
  AMAZON_LABEL_DOWNLOAD: (encodedUrl) => `${API_BASE_URL}/api/amazonlabelseparator/download/${encodedUrl}`,

  // Home Goods
  HOMEGOODS_PROCESS: `${API_BASE_URL}/api/homegoods/process`,
  HOMEGOODS_STATUS: (processId) => `${API_BASE_URL}/api/homegoods/status/${processId}`,
  HOMEGOODS_DOWNLOAD_SUMMARY: (processId) => `${API_BASE_URL}/api/homegoods/download/summary/${processId}`,
  HOMEGOODS_DOWNLOAD_IMPORT: (processId) => `${API_BASE_URL}/api/homegoods/download/import/${processId}`,

  // Pallet Labels
  PALLET_LABELS_PROCESS: `${API_BASE_URL}/api/palletlabels/process`,
  PALLET_LABELS_STATUS: (processId) => `${API_BASE_URL}/api/palletlabels/status/${processId}`,
  PALLET_LABELS_SAMPLE: `${API_BASE_URL}/api/palletlabels/sample`,
  PALLET_LABELS_DOWNLOAD_PALLET: (processId) => `${API_BASE_URL}/api/palletlabels/download/pallet/${processId}`,
  PALLET_LABELS_DOWNLOAD_BOL: (processId) => `${API_BASE_URL}/api/palletlabels/download/bol/${processId}`,
  PALLET_LABELS_DOWNLOAD_ALL: (processId) => `${API_BASE_URL}/api/palletlabels/download/all/${processId}`,

  // PDQ Labels
  PDQ_LABELS_PROCESS: `${API_BASE_URL}/api/pdqlabels/process`,
  PDQ_LABELS_STATUS: (processId) => `${API_BASE_URL}/api/pdqlabels/status/${processId}`,
  PDQ_LABELS_SAMPLE_SHIPPING: `${API_BASE_URL}/api/pdqlabels/sample/shipping`,
  PDQ_LABELS_SAMPLE_CASE: `${API_BASE_URL}/api/pdqlabels/sample/case`,
  PDQ_LABELS_DOWNLOAD: (processId) => `${API_BASE_URL}/api/pdqlabels/download/${processId}`,

  // Carton Labels
  CARTON_LABELS_PROCESS: `${API_BASE_URL}/api/carton-labels/process`,
  CARTON_LABELS_STATUS: (processId) => `${API_BASE_URL}/api/carton-labels/status/${processId}`,
  CARTON_LABELS_DOWNLOAD: (processId) => `${API_BASE_URL}/api/carton-labels/download/${processId}`,

  // Safavieh Invoices
  SAFAVIEH_INVOICES_GENERATE: `${API_BASE_URL}/api/expense-allocation-invoice/generate-invoices`,
  SAFAVIEH_INVOICES_STATUS: (processId) => `${API_BASE_URL}/api/expense-allocation-invoice/status/${processId}`,
  SAFAVIEH_INVOICES_DOWNLOAD: (encodedUrl) => `${API_BASE_URL}/api/expense-allocation-invoice/download/${encodedUrl}`,
  SAFAVIEH_INVOICES_TEMPLATE: `${API_BASE_URL}/api/expense-allocation-invoice/download-template`,

  // AMA9999 UCC Labels
  AMA9999_UCC_PROCESS: `${API_BASE_URL}/api/ama9999ucclabels/process-pdfs`,
  AMA9999_UCC_DOWNLOAD: (encodedUrl) => `${API_BASE_URL}/api/ama9999ucclabels/download/${encodedUrl}`,

  // Power BI
  POWERBI_UPLOAD_DATA: `${API_BASE_URL}/api/powerbi/upload-data`,
  POWERBI_EMBED_TOKEN: (reportId) => `${API_BASE_URL}/api/powerbi/embed-token/${reportId}`,

  // Sales Order Creation
  SALES_ORDER_PROCESS: `${API_BASE_URL}/api/sales-order/process-files`,
  SALES_ORDER_STATUS: (processId) => `${API_BASE_URL}/api/sales-order/status/${processId}`,
  SALES_ORDER_DOWNLOAD: (processId) => `${API_BASE_URL}/api/sales-order/download/${processId}`,
  SALES_ORDER_LOCATION: (locationId) => `${API_BASE_URL}/api/sales-order/process-location/${locationId}`,
  SALES_ORDER_SPECIAL: (specialType) => `${API_BASE_URL}/api/sales-order/process-special/${specialType}`,

  // Export Images
  EXPORT_IMAGES_PROCESS: `${API_BASE_URL}/api/exportimages/export-images`,
  EXPORT_IMAGES_STATUS: (processId) => `${API_BASE_URL}/api/exportimages/status/${processId}`,
  EXPORT_IMAGES_DOWNLOAD_RESULT: (processId) => `${API_BASE_URL}/api/exportimages/download-result/${processId}`,
  EXPORT_IMAGES_DOWNLOAD: (encodedUrl) => `${API_BASE_URL}/api/exportimages/download/${encodedUrl}`,
  EXPORT_IMAGES_TEMPLATE: `${API_BASE_URL}/api/exportimages/download-template`,

  // Item Image Grouping
  ITEM_IMAGE_GROUPING_PROCESS: `${API_BASE_URL}/api/itemimagegrouping/process-items`,
  ITEM_IMAGE_GROUPING_DOWNLOAD: (encodedUrl) => `${API_BASE_URL}/api/itemimagegrouping/download/${encodedUrl}`,
  ITEM_IMAGE_GROUPING_TEMPLATE: `${API_BASE_URL}/api/itemimagegrouping/download-template`,

  // PDF to Excel
  PDF_TO_EXCEL_CONVERT: `${API_BASE_URL}/api/PDFtoExcel/convert`,
  PDF_TO_EXCEL_STATUS: (processId) => `${API_BASE_URL}/api/PDFtoExcel/status/${processId}`,
  PDF_TO_EXCEL_DOWNLOAD: (processId) => `${API_BASE_URL}/api/PDFtoExcel/download/${processId}`,
  PDF_TO_EXCEL_LABEL_TYPES: `${API_BASE_URL}/api/PDFtoExcel/label-types`,
  PDF_TO_EXCEL_HEALTH: `${API_BASE_URL}/api/PDFtoExcel/health`,

  // Product Details
  PRODUCT_DETAILS_TEST: `${API_BASE_URL}/api/ProductDetails/test`,
  PRODUCT_DETAILS_PROCESS_IMAGE: `${API_BASE_URL}/api/ProductDetails/process-image`,
  PRODUCT_DETAILS_PROCESS_BATCH: `${API_BASE_URL}/api/ProductDetails/process-batch`,
  PRODUCT_DETAILS_PROCESS_COLORS: `${API_BASE_URL}/api/ProductDetails/process-colors`,
  PRODUCT_DETAILS_STATUS: (processId) => `${API_BASE_URL}/api/ProductDetails/status/${processId}`,
  PRODUCT_DETAILS_CANCEL: (processId) => `${API_BASE_URL}/api/ProductDetails/cancel/${processId}`,
  PRODUCT_DETAILS_DOWNLOAD: (fileUrl) => `${API_BASE_URL}/api/ProductDetails/download?fileUrl=${encodeURIComponent(fileUrl)}`,
  PRODUCT_DETAILS_TEMPLATE: (templateType) => `${API_BASE_URL}/api/ProductDetails/template/${templateType}`,

  // Marketing Copies
  MARKETING_COPIES_PROCESS: `${API_BASE_URL}/api/MarketingCopies/process`,
  MARKETING_COPIES_STATUS: (processId) => `${API_BASE_URL}/api/MarketingCopies/status/${processId}`,
  MARKETING_COPIES_DOWNLOAD: (processId) => `${API_BASE_URL}/api/MarketingCopies/download/${processId}`,
  MARKETING_COPIES_TEMPLATE: `${API_BASE_URL}/api/MarketingCopies/template`,

  // PDF Exports
  PDF_EXPORT_VIDEO_LINKS: `${API_BASE_URL}/api/PDFExport/getVideoLinks`,
  PDF_EXPORT_ASSEMBLY_LINKS: `${API_BASE_URL}/api/PDFExport/getAssemblyLinks`,
  PDF_EXPORT_EU_ASSEMBLY_LINKS: `${API_BASE_URL}/api/PDFExport/getEUAssemblyLinks`,
  PDF_EXPORT_FLAMMABILITY_LINKS: `${API_BASE_URL}/api/PDFExport/getFlammabilityReportLinks`,
  PDF_EXPORT_STATUS: (processId) => `${API_BASE_URL}/api/PDFExport/status/${processId}`,
  PDF_EXPORT_DOWNLOAD: (processId) => `${API_BASE_URL}/api/PDFExport/download/${processId}`,
  PDF_EXPORT_LAST_UPDATED_DATES: `${API_BASE_URL}/api/PDFExport/getLastUpdatedDates`,

  // General Excel Exports
  GENERAL_EXPORT_ITEMS_DETAIL: `${API_BASE_URL}/api/GeneralExport/getItemsDetail`,
  GENERAL_EXPORT_EU_IMAGE_LINKS: `${API_BASE_URL}/api/GeneralExport/getEUImageLinks`,
  GENERAL_EXPORT_US_IMAGE_LINKS: `${API_BASE_URL}/api/GeneralExport/getUSImageLinks`,
  GENERAL_EXPORT_UNPUBLISHED_RUGS: `${API_BASE_URL}/api/GeneralExport/getUnpublishedRugs`,
  GENERAL_EXPORT_UNPUBLISHED_NON_RUGS: `${API_BASE_URL}/api/GeneralExport/getUnpublishedNonRugs`,
  GENERAL_EXPORT_PUBLISHED_RUGS: `${API_BASE_URL}/api/GeneralExport/getPublishedRugs`,
  GENERAL_EXPORT_PUBLISHED_NON_RUGS: `${API_BASE_URL}/api/GeneralExport/getPublishedNonRugs`,
  GENERAL_EXPORT_IMAGES_DATA: `${API_BASE_URL}/api/GeneralExport/getImagesData`,
  GENERAL_EXPORT_PHOTOS_DP_DATA: `${API_BASE_URL}/api/GeneralExport/getPhotosDPData`,
  GENERAL_EXPORT_EU_ITEMS_DETAIL_FULL: `${API_BASE_URL}/api/GeneralExport/getEUItemsDetailFull`,
  GENERAL_EXPORT_ASSEMBLY_PDF_LINKS: `${API_BASE_URL}/api/GeneralExport/getAssemblyPDFLinks`,
  GENERAL_EXPORT_STATUS: (processId) => `${API_BASE_URL}/api/GeneralExport/status/${processId}`,
  GENERAL_EXPORT_DOWNLOAD: (processId) => `${API_BASE_URL}/api/GeneralExport/download/${processId}`,
  GENERAL_EXPORT_LAST_UPDATED_DATES: `${API_BASE_URL}/api/GeneralExport/getLastUpdatedDates`,

  // Document Translation
  DOCUMENT_TRANSLATION_TRANSLATE_TEXT: `${API_BASE_URL}/api/DocumentTranslation/translate-text`,
  DOCUMENT_TRANSLATION_TRANSLATE_DOCUMENT: `${API_BASE_URL}/api/DocumentTranslation/translate-document`,
  DOCUMENT_TRANSLATION_STATUS: (processId) => `${API_BASE_URL}/api/DocumentTranslation/status/${processId}`,
  DOCUMENT_TRANSLATION_DOWNLOAD: (processId) => `${API_BASE_URL}/api/DocumentTranslation/download/${processId}`,
  DOCUMENT_TRANSLATION_TEMPLATE: `${API_BASE_URL}/api/DocumentTranslation/template`,

  // Inactive Items
  INACTIVE_ITEMS_PROCESS: `${API_BASE_URL}/api/InactiveItems/process`,
  INACTIVE_ITEMS_STATUS: (processId) => `${API_BASE_URL}/api/InactiveItems/status/${processId}`,
  INACTIVE_ITEMS_DOWNLOAD: (processId) => `${API_BASE_URL}/api/InactiveItems/download/${processId}`,
  INACTIVE_ITEMS_PROCESS_LEGACY: `${API_BASE_URL}/api/InactiveItems/processInactiveItems`,

  // FTP Transfer
  FTP_TRANSFER_TEST: `${API_BASE_URL}/api/FTPTransfer/test`,
  FTP_TRANSFER_LIST_SUBFOLDERS: `${API_BASE_URL}/api/FTPTransfer/listSubfolders`,
  FTP_TRANSFER_START_PROCESSING: `${API_BASE_URL}/api/FTPTransfer/startProcessing`,
  FTP_TRANSFER_STATUS: (processId) => `${API_BASE_URL}/api/FTPTransfer/status/${processId}`,
  FTP_TRANSFER_STOP: (processId) => `${API_BASE_URL}/api/FTPTransfer/stop/${processId}`,
  FTP_TRANSFER_CLEAR: (processId) => `${API_BASE_URL}/api/FTPTransfer/clear/${processId}`,

  // Remove Background
  REMOVE_BACKGROUND_TEST: `${API_BASE_URL}/api/RemoveBackground/test`,
  REMOVE_BACKGROUND_GET_API_CALLS_LEFT: `${API_BASE_URL}/api/RemoveBackground/getApiCallsLeft`,
  REMOVE_BACKGROUND_REMOVE: `${API_BASE_URL}/api/RemoveBackground/removeBackground`,

  // Price Scraper
  PRICE_SCRAPER_IMPORT: `${API_BASE_URL}/api/PriceScraper/import`,
  PRICE_SCRAPER_TEMPLATE: `${API_BASE_URL}/api/PriceScraper/template`,
  PRICE_SCRAPER_EXPORT: `${API_BASE_URL}/api/PriceScraper/export`,
  PRICE_SCRAPER_DOWNLOAD_BRIDGE: `${API_BASE_URL}/api/PriceScraper/downloadBridge`,
  PRICE_SCRAPER_SAVE_RESULTS: `${API_BASE_URL}/api/PriceScraper/save-results`,
  // V2 — EC2-backed DB-queued scraper
  PRICE_SCRAPER_V2_PARSE_EXCEL: `${API_BASE_URL}/api/PriceScraper/v2/parse-excel`,
  PRICE_SCRAPER_V2_CREATE_JOB: `${API_BASE_URL}/api/PriceScraper/v2/jobs`,
  PRICE_SCRAPER_V2_LIST_JOBS: `${API_BASE_URL}/api/PriceScraper/v2/jobs`,
  PRICE_SCRAPER_V2_GET_JOB: (id) => `${API_BASE_URL}/api/PriceScraper/v2/jobs/${id}`,
  PRICE_SCRAPER_V2_CANCEL_JOB: (id) => `${API_BASE_URL}/api/PriceScraper/v2/jobs/${id}/cancel`,
  // BBB catalog crawl (item ID + price + url + description for all Safavieh items on BBB)
  BBB_CATALOG_START: `${API_BASE_URL}/api/PriceScraper/v2/bbb-catalog/start`,
  BBB_CATALOG_STATUS: `${API_BASE_URL}/api/PriceScraper/v2/bbb-catalog/status`,
  BBB_CATALOG_CANCEL: `${API_BASE_URL}/api/PriceScraper/v2/bbb-catalog/cancel`,
  BBB_CATALOG_LOOKUP: (itemId) => `${API_BASE_URL}/api/PriceScraper/v2/bbb-catalog/lookup?itemId=${encodeURIComponent(itemId)}`,

  // SAF1909 Inventory Analysis
  SAF1909_GET_LAST_UPDATED: `${API_BASE_URL}/api/SAF1909/getLastUpdated`,
  SAF1909_DOWNLOAD_YEARLY_SUMMARY: `${API_BASE_URL}/api/SAF1909/downloadYearlySummary`,
  SAF1909_GENERATE_REPORT: `${API_BASE_URL}/api/SAF1909/generateReport`,

  // State Freight
  // Reports Scheduler (migrated from the standalone ReportsGeneration service)
  REPORTS_SCHEDULER_REPORTS:    `${API_BASE_URL}/api/ReportsScheduler/reports`,
  REPORTS_SCHEDULER_RUNS:       `${API_BASE_URL}/api/ReportsScheduler/runs`,
  REPORTS_SCHEDULER_RUN:        (id) => `${API_BASE_URL}/api/ReportsScheduler/runs/${id}`,
  REPORTS_SCHEDULER_RUN_DOWNLOAD: (id) => `${API_BASE_URL}/api/ReportsScheduler/runs/${id}/download`,
  REPORTS_SCHEDULER_SCHEDULES:  `${API_BASE_URL}/api/ReportsScheduler/schedules`,
  REPORTS_SCHEDULER_SCHEDULE:   (id) => `${API_BASE_URL}/api/ReportsScheduler/schedules/${id}`,
  REPORTS_SCHEDULER_SCHEDULE_RUN: (id) => `${API_BASE_URL}/api/ReportsScheduler/schedules/${id}/run`,
  REPORTS_SCHEDULER_CRON_PREVIEW: `${API_BASE_URL}/api/ReportsScheduler/schedules/preview`,
  REPORTS_SCHEDULER_TIMEZONES:  `${API_BASE_URL}/api/ReportsScheduler/schedules/timezones`,
  REPORTS_SCHEDULER_HEALTH:     `${API_BASE_URL}/api/ReportsScheduler/warehouse/health`,
  REPORTS_SCHEDULER_SCHEDULES_STORE: `${API_BASE_URL}/api/ReportsScheduler/schedules/store`,
  REPORTS_SCHEDULER_EMAIL:      `${API_BASE_URL}/api/ReportsScheduler/email`,
  REPORTS_SCHEDULER_EMAIL_TEST: `${API_BASE_URL}/api/ReportsScheduler/email/test`,
  REPORTS_SCHEDULER_EMAIL_RUN:  (id) => `${API_BASE_URL}/api/ReportsScheduler/email/runs/${id}`,
  REPORTS_SCHEDULER_CUSTOM_REPORTS: `${API_BASE_URL}/api/ReportsScheduler/custom-reports`,
  REPORTS_SCHEDULER_CUSTOM_REPORT:  (key) => `${API_BASE_URL}/api/ReportsScheduler/custom-reports/${key}`,
  REPORTS_SCHEDULER_CUSTOM_DRAFT:   `${API_BASE_URL}/api/ReportsScheduler/custom-reports/draft`,
  REPORTS_SCHEDULER_CUSTOM_VALIDATE:`${API_BASE_URL}/api/ReportsScheduler/custom-reports/validate`,
  REPORTS_SCHEDULER_CUSTOM_PREVIEW: `${API_BASE_URL}/api/ReportsScheduler/custom-reports/preview`,
  REPORTS_SCHEDULER_CUSTOM_PARAMS:  (key) => `${API_BASE_URL}/api/ReportsScheduler/custom-reports/${key}/parameters`,
  REPORTS_SCHEDULER_CUSTOM_SCHEMA:  `${API_BASE_URL}/api/ReportsScheduler/custom-reports/schema`,

  // Canadian 13 Provinces Freight (Purolator Ground)
  CANADIAN_FREIGHT_CALCULATE: `${API_BASE_URL}/api/CanadianFreight/calculateFreight`,
  CANADIAN_FREIGHT_STATUS: (processId) => `${API_BASE_URL}/api/CanadianFreight/status/${processId}`,
  CANADIAN_FREIGHT_DOWNLOAD: (processId) => `${API_BASE_URL}/api/CanadianFreight/download/${processId}`,

  // EU Freight (UPS + FedEx into Europe)
  EU_FREIGHT_CALCULATE: `${API_BASE_URL}/api/EUFreight/calculateFreight`,
  EU_FREIGHT_STATUS: (processId) => `${API_BASE_URL}/api/EUFreight/status/${processId}`,
  EU_FREIGHT_DOWNLOAD: (processId) => `${API_BASE_URL}/api/EUFreight/download/${processId}`,

  STATE_FREIGHT_CALCULATE: `${API_BASE_URL}/api/StateFreight/calculateFreight`,
  STATE_FREIGHT_STATUS: (processId) => `${API_BASE_URL}/api/StateFreight/status/${processId}`,
  STATE_FREIGHT_DOWNLOAD: (processId) => `${API_BASE_URL}/api/StateFreight/download/${processId}`,

  // Bilingual Labels
  BILINGUAL_LABELS_PROCESS: `${API_BASE_URL}/api/bilingual-labels/process`,
  BILINGUAL_LABELS_STATUS: (processId) => `${API_BASE_URL}/api/bilingual-labels/status/${processId}`,
  BILINGUAL_LABELS_DOWNLOAD: (processId) => `${API_BASE_URL}/api/bilingual-labels/download/${processId}`,
  BILINGUAL_LABELS_TEMPLATE: (type) => `${API_BASE_URL}/api/bilingual-labels/download-template/${type}`,

  // PO Distribution
  PO_DISTRIBUTION_PROCESS: `${API_BASE_URL}/api/po-distribution/process`,
  PO_DISTRIBUTION_STATUS: (processId) => `${API_BASE_URL}/api/po-distribution/status/${processId}`,
  PO_DISTRIBUTION_DOWNLOAD: (processId) => `${API_BASE_URL}/api/po-distribution/download/${processId}`,
  PO_DISTRIBUTION_SAMPLE: `${API_BASE_URL}/api/po-distribution/download-sample`,

  // PO Distribution WHS
  PO_DISTRIBUTION_WHS_PROCESS: `${API_BASE_URL}/api/po-distribution-whs/process`,
  PO_DISTRIBUTION_WHS_SALES_INFO: `${API_BASE_URL}/api/po-distribution-whs/sales-data-info`,
  PO_DISTRIBUTION_WHS_WAREHOUSE_LOGIC_FILE: `${API_BASE_URL}/api/po-distribution-whs/warehouse-logic-file`,

  // Rug Gallery Labels (Master Retail Rugs)
  RUG_GALLERY_LABELS_PROCESS: `${API_BASE_URL}/api/RugGalleryLabels/process`,
  RUG_GALLERY_LABELS_STATUS: (processId) => `${API_BASE_URL}/api/RugGalleryLabels/status/${processId}`,
  RUG_GALLERY_LABELS_DOWNLOAD: (processId) => `${API_BASE_URL}/api/RugGalleryLabels/download/${processId}`,
  RUG_GALLERY_LABELS_SAMPLE: (lookupType) => `${API_BASE_URL}/api/RugGalleryLabels/download-sample/${lookupType}`,
  RUG_GALLERY_LABELS_HEALTH: `${API_BASE_URL}/api/RugGalleryLabels/health`,

  // User History
  USER_FILE_HISTORY: `${API_BASE_URL}/api/Users/userUploadOrDownloadHistory`,

  // AI Prompts
  AI_PROMPTS_LIST: (mode) => `${API_BASE_URL}/api/AIPrompts?mode=${mode}`,
  AI_PROMPTS_CREATE: `${API_BASE_URL}/api/AIPrompts`,
  AI_PROMPTS_UPDATE: (id) => `${API_BASE_URL}/api/AIPrompts/${id}`,
  AI_PROMPTS_DELETE: (id) => `${API_BASE_URL}/api/AIPrompts/${id}`,

  // AI Image Generator History
  AI_IMAGE_HISTORY: (page, pageSize) => `${API_BASE_URL}/api/AIImageGenerator/history?page=${page}&pageSize=${pageSize}`,
  AI_IMAGE_BATCH: (batchId) => `${API_BASE_URL}/api/AIImageGenerator/history/${batchId}`,
  AI_IMAGE_BATCH_DOWNLOAD: (batchId) => `${API_BASE_URL}/api/AIImageGenerator/history/${batchId}/download`,
  AI_IMAGE_SAVE_BATCH_HISTORY: `${API_BASE_URL}/api/AIImageGenerator/saveBatchHistory`,
  AI_IMAGE_DOWNLOAD_SINGLE: (id) => `${API_BASE_URL}/api/AIImageGenerator/download-image/${id}`,
  AI_IMAGE_PROXY: (id) => `${API_BASE_URL}/api/AIImageGenerator/image/${id}`,
  AI_IMAGE_COLLECTIONS: `${API_BASE_URL}/api/AIImageGenerator/collections`,
  AI_IMAGE_GENERATE_PROMPTS: `${API_BASE_URL}/api/AIImageGenerator/generate-prompts`,
  AI_IMAGE_BATCH_INPUTS: (batchId) => `${API_BASE_URL}/api/AIImageGenerator/batch-inputs/${batchId}`,
  AI_IMAGE_DELETE_BATCH_INPUT: (batchId, inputId) => `${API_BASE_URL}/api/AIImageGenerator/batch-inputs/${batchId}/${inputId}`,
  AI_IMAGE_DELETE_ALL_BATCH_INPUTS: (batchId) => `${API_BASE_URL}/api/AIImageGenerator/batch-inputs/${batchId}`,

  // Sales Dashboard
  SALES_DASHBOARD_DATA: `${API_BASE_URL}/api/SalesDashboard/data`,
  SALES_DASHBOARD_ITEMS_LOOKUP: `${API_BASE_URL}/api/SalesDashboard/items-lookup`,

  // Sales Dashboard v2 (self-hosted ClickHouse warehouse, server-aggregated)
  SALES_V2_DATE_RANGE: `${API_BASE_URL}/api/SalesDashboardV2/date-range`,
  SALES_V2_SUMMARY: `${API_BASE_URL}/api/SalesDashboardV2/summary`,
  SALES_V2_TREND: `${API_BASE_URL}/api/SalesDashboardV2/trend`,
  SALES_V2_FORECAST: `${API_BASE_URL}/api/SalesDashboardV2/forecast`,
  SALES_V2_TOP_ITEMS: `${API_BASE_URL}/api/SalesDashboardV2/top-items`,
  SALES_V2_TOP_CUSTOMERS: `${API_BASE_URL}/api/SalesDashboardV2/top-customers`,
  SALES_V2_BY_COLLECTION: `${API_BASE_URL}/api/SalesDashboardV2/by-collection`,
  SALES_V2_BY_WAREHOUSE: `${API_BASE_URL}/api/SalesDashboardV2/by-warehouse`,
  SALES_V2_BY_STATE: `${API_BASE_URL}/api/SalesDashboardV2/by-state`,
  SALES_V2_BY_COLOR: `${API_BASE_URL}/api/SalesDashboardV2/by-color`,
  SALES_V2_BY_SIZE: `${API_BASE_URL}/api/SalesDashboardV2/by-size`,
  SALES_V2_BY_STYLE: `${API_BASE_URL}/api/SalesDashboardV2/by-style`,
  SALES_V2_BY_ZIP: `${API_BASE_URL}/api/SalesDashboardV2/by-zip`,
  SALES_V2_DROPSHIP_SPLIT: `${API_BASE_URL}/api/SalesDashboardV2/dropship-split`,
  SALES_V2_FILTERS: `${API_BASE_URL}/api/SalesDashboardV2/filters`,
  SALES_V2_REPORT: `${API_BASE_URL}/api/SalesDashboardV2/report`,
  SALES_V2_REPORT_SERIES: `${API_BASE_URL}/api/SalesDashboardV2/report-series`,
  SALES_V2_CUSTOMER_ITEM_DETAILS: `${API_BASE_URL}/api/SalesDashboardV2/customer-item-details`,

  // Returns & Quality dashboard (self-hosted ClickHouse warehouse)
  RETURNS_DASH_SUMMARY: `${API_BASE_URL}/api/ReturnsDashboard/summary`,
  RETURNS_DASH_TREND: `${API_BASE_URL}/api/ReturnsDashboard/trend`,
  RETURNS_DASH_REPORT: `${API_BASE_URL}/api/ReturnsDashboard/report`,

  // RetailOS (retail ops / promotion-lift dashboard; snapshot + packs served from S3, sales live from ClickHouse)
  RETAILOS_SNAPSHOT: `${API_BASE_URL}/api/RetailOs/snapshot`,
  RETAILOS_PROMOTION_META: `${API_BASE_URL}/api/RetailOs/promotions/meta`,
  RETAILOS_PACK: (key) => `${API_BASE_URL}/api/RetailOs/promotions/pack/${encodeURIComponent(key)}`,
  RETAILOS_VERIFY: `${API_BASE_URL}/api/RetailOs/verify`,
  RETAILOS_WORKSPACE: `${API_BASE_URL}/api/RetailOs/workspace`,
  RETAILOS_WORKSPACE_CHANGES: `${API_BASE_URL}/api/RetailOs/workspace/changes`,
  RETAILOS_ACTIVITY: `${API_BASE_URL}/api/RetailOs/workspace/activity`,
  RETAILOS_ANALYSIS_STATUS: `${API_BASE_URL}/api/RetailOs/analysis/status`,
  // Phase 4 — promotions as editable records
  RETAILOS_PROMOTIONS: `${API_BASE_URL}/api/RetailOs/promotions`,
  RETAILOS_PROMOTION: (id) => `${API_BASE_URL}/api/RetailOs/promotions/${encodeURIComponent(id)}`,
  RETAILOS_IMPORT_PREVIEW: `${API_BASE_URL}/api/RetailOs/promotions/import/preview`,
  RETAILOS_IMPORT: `${API_BASE_URL}/api/RetailOs/promotions/import`,
  RETAILOS_BATCHES: `${API_BASE_URL}/api/RetailOs/promotions/batches`,
  RETAILOS_BATCH_PREVIEW: (id) => `${API_BASE_URL}/api/RetailOs/promotions/batches/${encodeURIComponent(id)}/preview`,
  RETAILOS_BATCH_EXCLUDE: (id) => `${API_BASE_URL}/api/RetailOs/promotions/batches/${encodeURIComponent(id)}/exclude`,
  RETAILOS_BATCH_RESTORE: (id) => `${API_BASE_URL}/api/RetailOs/promotions/batches/${encodeURIComponent(id)}/restore`,
  RETAILOS_SEED: `${API_BASE_URL}/api/RetailOs/promotions/seed`,
  RETAILOS_SEED_STATUS: `${API_BASE_URL}/api/RetailOs/promotions/seed/status`,
  RETAILOS_ANALYSIS_WINDOW: (id, end, method) => `${API_BASE_URL}/api/RetailOs/analysis/window/${encodeURIComponent(id)}?end=${encodeURIComponent(end)}&method=${encodeURIComponent(method || 'weekday')}`,

  // New Items (selling-team launchpad, ClickHouse warehouse)
  NEW_ITEMS_SUMMARY: `${API_BASE_URL}/api/NewItems/summary`,
  NEW_ITEMS_LIST: `${API_BASE_URL}/api/NewItems/list`,
  NEW_ITEMS_DETAIL: `${API_BASE_URL}/api/NewItems/detail`,

  // Customer Style Gaps (feeds + CSL + warehouse)
  CUSTOMER_GAPS_CUSTOMERS: `${API_BASE_URL}/api/CustomerGaps/customers`,
  CUSTOMER_GAPS_GAP: `${API_BASE_URL}/api/CustomerGaps/gap`,
  CUSTOMER_GAPS_ITEM: `${API_BASE_URL}/api/CustomerGaps/item-customers`,

  // Collection Launch Performance (ClickHouse warehouse)
  COLLECTION_LAUNCHES_OVERVIEW: `${API_BASE_URL}/api/CollectionLaunches/overview`,
  COLLECTION_LAUNCHES_DETAIL: `${API_BASE_URL}/api/CollectionLaunches/detail`,

  // Sales Pulse (ClickHouse warehouse)
  SALES_PULSE_PULSE: `${API_BASE_URL}/api/SalesPulse/pulse`,
  SALES_PULSE_MOVERS: `${API_BASE_URL}/api/SalesPulse/movers`,
  SALES_PULSE_CUSTOMER: `${API_BASE_URL}/api/SalesPulse/customer`,

  // Asset Explorer
  ASSET_EXPLORER_STATS: `${API_BASE_URL}/api/AssetExplorer/stats`,
  ASSET_EXPLORER_SEARCH: `${API_BASE_URL}/api/AssetExplorer/search`,
  ASSET_EXPLORER_GRAPH: `${API_BASE_URL}/api/AssetExplorer/graph`,
  ASSET_EXPLORER_EXPAND: `${API_BASE_URL}/api/AssetExplorer/expand`,
  ASSET_EXPLORER_SUGGEST: `${API_BASE_URL}/api/AssetExplorer/suggest`,
  ASSET_EXPLORER_EXPAND_FAMILY: `${API_BASE_URL}/api/AssetExplorer/expandFamily`,
  ASSET_EXPLORER_SPARQL: `${API_BASE_URL}/api/AssetExplorer/sparql`,

  // Sales Dashboard AI
  SALES_DASHBOARD_AI_INSIGHTS: `${API_BASE_URL}/api/SalesDashboardAI/insights`,
  SALES_DASHBOARD_AI_FORECAST: `${API_BASE_URL}/api/SalesDashboardAI/forecast`,
  SALES_DASHBOARD_AI_CUSTOMERS: `${API_BASE_URL}/api/SalesDashboardAI/customers`,
  SALES_DASHBOARD_AI_QUERY: `${API_BASE_URL}/api/SalesDashboardAI/query`,
  SALES_DASHBOARD_AI_RECOMMENDATIONS: `${API_BASE_URL}/api/SalesDashboardAI/recommendations`,
  SALES_DASHBOARD_AI_DEEP_ANALYZE: `${API_BASE_URL}/api/SalesDashboardAI/deep-analyze`,

  // Bulk Image Downloader
  BULK_IMAGE_DOWNLOADER_PROCESS: `${API_BASE_URL}/api/BulkImageDownloader/process`,
  BULK_IMAGE_DOWNLOADER_PROCESS_URLS: `${API_BASE_URL}/api/BulkImageDownloader/process-urls`,
  BULK_IMAGE_DOWNLOADER_STATUS: (processId) => `${API_BASE_URL}/api/BulkImageDownloader/status/${processId}`,
  BULK_IMAGE_DOWNLOADER_DOWNLOAD: (processId) => `${API_BASE_URL}/api/BulkImageDownloader/download/${processId}`,

  // File Converter
  FILE_CONVERTER_CONVERT: `${API_BASE_URL}/api/FileConverter/convert`,
  FILE_CONVERTER_FORMATS: `${API_BASE_URL}/api/FileConverter/formats`,

  // Amazon Rug Titles
  AMAZON_RUG_TITLES_RUNS: `${API_BASE_URL}/api/AmazonRugTitles/runs`,
  AMAZON_RUG_TITLES_RUN_RESULTS: (runId, params) => `${API_BASE_URL}/api/AmazonRugTitles/runs/${runId}/results?${params}`,
  AMAZON_RUG_TITLES_ITEM_HISTORY: (itemId) => `${API_BASE_URL}/api/AmazonRugTitles/items/${encodeURIComponent(itemId)}/history`,
  AMAZON_RUG_TITLES_MISSING: (runId) => `${API_BASE_URL}/api/AmazonRugTitles/runs/${runId}/missing`,
  AMAZON_RUG_TITLES_FILTERS: (runId, params) => `${API_BASE_URL}/api/AmazonRugTitles/runs/${runId}/filters${params ? '?' + params : ''}`,
  AMAZON_RUG_TITLES_EXPORT: (runId, params) => `${API_BASE_URL}/api/AmazonRugTitles/runs/${runId}/export?${params}`,
  AMAZON_RUG_TITLES_COMPARE: (params) => `${API_BASE_URL}/api/AmazonRugTitles/compare?${params}`,

  // AI Photo Pipeline
  PHOTO_PIPELINE_RUN: `${API_BASE_URL}/api/AIPhotoPipeline/run`,
  PHOTO_PIPELINE_RUNS: `${API_BASE_URL}/api/AIPhotoPipeline/runs`,
  PHOTO_PIPELINE_RUN_DETAILS: (runId) => `${API_BASE_URL}/api/AIPhotoPipeline/runs/${runId}`,
  PHOTO_PIPELINE_RUN_PROGRESS: (runId) => `${API_BASE_URL}/api/AIPhotoPipeline/runs/${runId}/progress`,
  PHOTO_PIPELINE_RUN_PAUSE: (runId) => `${API_BASE_URL}/api/AIPhotoPipeline/runs/${runId}/pause`,
  PHOTO_PIPELINE_RUN_RESUME: (runId) => `${API_BASE_URL}/api/AIPhotoPipeline/runs/${runId}/resume`,
  PHOTO_PIPELINE_RUN_CANCEL: (runId) => `${API_BASE_URL}/api/AIPhotoPipeline/runs/${runId}/cancel`,
  PHOTO_PIPELINE_REVIEW_QUEUE: `${API_BASE_URL}/api/AIPhotoPipeline/review-queue`,
  PHOTO_PIPELINE_APPROVE: (imageId) => `${API_BASE_URL}/api/AIPhotoPipeline/review/${imageId}/approve`,
  PHOTO_PIPELINE_REJECT: (imageId) => `${API_BASE_URL}/api/AIPhotoPipeline/review/${imageId}/reject`,
  PHOTO_PIPELINE_BULK_APPROVE: `${API_BASE_URL}/api/AIPhotoPipeline/review/bulk-approve`,
  PHOTO_PIPELINE_BULK_REJECT: `${API_BASE_URL}/api/AIPhotoPipeline/review/bulk-reject`,
  PHOTO_PIPELINE_STYLE_RULES: `${API_BASE_URL}/api/AIPhotoPipeline/style-rules`,
  PHOTO_PIPELINE_STYLE_RULE_DELETE: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/style-rules/${id}`,
  PHOTO_PIPELINE_PAIRING_RULES: `${API_BASE_URL}/api/AIPhotoPipeline/pairing-rules`,
  PHOTO_PIPELINE_PAIRING_RULE_DELETE: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/pairing-rules/${id}`,
  PHOTO_PIPELINE_CHAT: `${API_BASE_URL}/api/AIPhotoPipeline/chat`,
  PHOTO_PIPELINE_ANALYTICS: `${API_BASE_URL}/api/AIPhotoPipeline/analytics/overview`,
  PHOTO_PIPELINE_FEEDBACK_PATTERNS: `${API_BASE_URL}/api/AIPhotoPipeline/analytics/feedback-patterns`,
  PHOTO_PIPELINE_S3_BROWSE: (itemId) => `${API_BASE_URL}/api/AIPhotoPipeline/s3-browse/${itemId}`,
  PHOTO_PIPELINE_IMAGE_PROXY: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/image/${id}`,
  PHOTO_PIPELINE_IMAGE_DOWNLOAD: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/download-image/${id}`,
  PHOTO_PIPELINE_SOURCE_IMAGE: (itemId) => `${API_BASE_URL}/api/AIPhotoPipeline/source-image/${itemId}`,
  PHOTO_PIPELINE_REGENERATE: (imageId) => `${API_BASE_URL}/api/AIPhotoPipeline/review/${imageId}/regenerate`,
  PHOTO_PIPELINE_APPLY_LEARNINGS: `${API_BASE_URL}/api/AIPhotoPipeline/feedback/apply-learnings`,
  PHOTO_PIPELINE_QUALITY_TREND: `${API_BASE_URL}/api/AIPhotoPipeline/analytics/quality-trend`,
  PHOTO_PIPELINE_COST_BREAKDOWN: `${API_BASE_URL}/api/AIPhotoPipeline/analytics/cost-breakdown`,
  PHOTO_PIPELINE_RUN_BATCH: `${API_BASE_URL}/api/AIPhotoPipeline/run/batch`,
  PHOTO_PIPELINE_EXPORT: `${API_BASE_URL}/api/AIPhotoPipeline/analytics/export`,
  PHOTO_PIPELINE_STYLE_RULE_UPDATE: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/style-rules/${id}`,
  PHOTO_PIPELINE_PAIRING_RULE_UPDATE: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/pairing-rules/${id}`,

  // V2 — Jobs, Shot Types, Room Scenes
  PIPELINE_V2_SHOT_TYPES: `${API_BASE_URL}/api/AIPhotoPipeline/v2/shot-types`,
  PIPELINE_V2_SHOT_TYPE: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/shot-types/${id}`,
  PIPELINE_V2_ROOM_SCENES: `${API_BASE_URL}/api/AIPhotoPipeline/v2/room-scenes`,
  PIPELINE_V2_CREATE_JOB: `${API_BASE_URL}/api/AIPhotoPipeline/v2/jobs`,
  PIPELINE_V2_JOBS: `${API_BASE_URL}/api/AIPhotoPipeline/v2/jobs`,
  PIPELINE_V2_JOB_DETAILS: (jobId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/jobs/${jobId}`,
  PIPELINE_V2_JOB_CANCEL: (jobId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/jobs/${jobId}/cancel`,
  PIPELINE_V2_JOB_IMAGES: (jobId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/jobs/${jobId}/images`,
  PIPELINE_V2_IMAGE_APPROVE: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/images/${id}/approve`,
  PIPELINE_V2_IMAGE_REJECT: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/images/${id}/reject`,
  PIPELINE_V2_BULK_APPROVE: `${API_BASE_URL}/api/AIPhotoPipeline/v2/images/bulk-approve`,
  PIPELINE_V2_ESTIMATE_COST: `${API_BASE_URL}/api/AIPhotoPipeline/v2/estimate-cost`,
  PIPELINE_V2_RESULTS: `${API_BASE_URL}/api/AIPhotoPipeline/v2/results`,
  PIPELINE_V2_IMAGE_DETAIL: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/images/${id}/detail`,
  PIPELINE_V2_JOB_FLOW: (jobId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/jobs/${jobId}/flow`,
  PIPELINE_V2_ITEM_IMAGES: (itemId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/items/${encodeURIComponent(itemId)}/images`,
  PIPELINE_V2_ITEM_SEARCH: (q) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/items/search?q=${encodeURIComponent(q)}`,
  PIPELINE_V2_COLLECTIONS: `${API_BASE_URL}/api/AIPhotoPipeline/v2/collections`,
  PIPELINE_V2_COLLECTION: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/collections/${id}`,
  PIPELINE_V2_COLLECTION_ADD_IMAGES: (id) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/collections/${id}/images`,
  PIPELINE_V2_COLLECTION_ADD_JOB: (id, jobId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/collections/${id}/jobs/${jobId}`,
  PIPELINE_V2_COLLECTION_REMOVE_IMAGE: (id, imageId) => `${API_BASE_URL}/api/AIPhotoPipeline/v2/collections/${id}/images/${imageId}`,

  // Rug Room Shots (admins + the "rug-room-shots" interface key; see rug-room-shots-worker/SPEC.md section 3.4)
  RRS_HEALTH: `${API_BASE_URL}/api/RugRoomShots/health`,
  RRS_CONFIG: `${API_BASE_URL}/api/RugRoomShots/config`,
  RRS_JOBS: `${API_BASE_URL}/api/RugRoomShots/jobs`,
  RRS_JOBS_UPLOAD: `${API_BASE_URL}/api/RugRoomShots/jobs/upload`,
  RRS_JOB: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}`,
  RRS_JOB_TARGETS: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/targets`,
  RRS_JOB_START: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/start`,
  RRS_JOB_CANCEL: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/cancel`,
  RRS_JOB_EXPORT: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/export`,
  RRS_JOB_REVIEW: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/review`,
  RRS_TARGET_STYLE: (targetId) => `${API_BASE_URL}/api/RugRoomShots/targets/${targetId}/style`,
  RRS_TARGET_ROOM: (targetId) => `${API_BASE_URL}/api/RugRoomShots/targets/${targetId}/room`,
  RRS_TARGET_EXCLUDE: (targetId) => `${API_BASE_URL}/api/RugRoomShots/targets/${targetId}/exclude`,
  RRS_GENERATION: (genId) => `${API_BASE_URL}/api/RugRoomShots/generations/${genId}`,
  RRS_GENERATION_REVIEW: (genId) => `${API_BASE_URL}/api/RugRoomShots/generations/${genId}/review`,
  RRS_GENERATION_REGENERATE: (genId) => `${API_BASE_URL}/api/RugRoomShots/generations/${genId}/regenerate`,
  RRS_ROOMS: `${API_BASE_URL}/api/RugRoomShots/rooms`,
  RRS_ROOMS_MATRIX: `${API_BASE_URL}/api/RugRoomShots/rooms/matrix`,
  RRS_ROOMS_SUGGEST: `${API_BASE_URL}/api/RugRoomShots/rooms/suggest`,
  RRS_ROOMS_SCAN: `${API_BASE_URL}/api/RugRoomShots/rooms/scan`,
  RRS_ROOM_CANDIDATES: (roomCode) => `${API_BASE_URL}/api/RugRoomShots/rooms/${encodeURIComponent(roomCode)}/candidates`,
  RRS_ROOM_STATUS: (roomCode) => `${API_BASE_URL}/api/RugRoomShots/rooms/${encodeURIComponent(roomCode)}/status`,
  RRS_ROOM_BASE: (roomCode) => `${API_BASE_URL}/api/RugRoomShots/rooms/${encodeURIComponent(roomCode)}/base`,
  // Page-added rooms and styles, bulk regenerate (SPEC 10). POST RRS_ROOMS (multipart) adds a room.
  RRS_ROOMS_NEXT_CODE: `${API_BASE_URL}/api/RugRoomShots/rooms/next-code`,
  RRS_STYLES: `${API_BASE_URL}/api/RugRoomShots/styles`,
  RRS_JOB_REGENERATE_PREVIEW: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/regenerate/preview`,
  RRS_JOB_REGENERATE: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/regenerate`,
  RRS_SPEND: `${API_BASE_URL}/api/RugRoomShots/spend`,
  RRS_EVENTS: `${API_BASE_URL}/api/RugRoomShots/events`,
  RRS_SETTINGS_PAUSE: `${API_BASE_URL}/api/RugRoomShots/settings/pause`,
  RRS_JOB_BATCHES: (jobId) => `${API_BASE_URL}/api/RugRoomShots/jobs/${jobId}/batches`,
  RRS_BATCH: (batchId) => `${API_BASE_URL}/api/RugRoomShots/batches/${batchId}`,
};

// Helper function to make API calls with authentication
export const apiCall = async (url, options = {}) => {
  const token = localStorage.getItem('jwtToken');

  const defaultHeaders = {
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  // Don't add Content-Type for FormData, browser will set it automatically with boundary
  if (options.body && !(options.body instanceof FormData)) {
    defaultHeaders['Content-Type'] = 'application/json';
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  // Support abort signal from options
  if (options.signal) {
    config.signal = options.signal;
  }

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      let errorMessage = 'Request failed';
      let errorBody = null;
      try {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          errorBody = errorData;
          errorMessage = errorData.error || errorData.message || errorMessage;
        } else {
          const textResponse = await response.text();
          errorMessage = `Server error: ${response.status} ${response.statusText}`;
          console.error('Non-JSON response:', textResponse.substring(0, 200));
        }
      } catch (parseError) {
        console.error('Error parsing error response:', parseError);
        errorMessage = `Server error: ${response.status} ${response.statusText}`;
      }
      // Additive: callers that need it can read the HTTP status and the JSON
      // error body (e.g. a 409 { code, current }); existing callers only use .message.
      const error = new Error(errorMessage);
      error.status = response.status;
      error.body = errorBody;
      throw error;
    }

    // Check if response has content before trying to parse JSON
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    }

    // Return the raw response for blob/arraybuffer/text handling
    return response;
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};

export default API_BASE_URL;
